function initOtherJobTitleFields() {
  document.querySelectorAll('[data-job-title-select]').forEach((select) => {
    const form = select.closest('form');
    if (!form) return;

    const input = form.querySelector('[data-other-job-title-input]');
    if (!input) return;

    function syncOtherJobTitleInput() {
      const show = select.value === 'Outro';
      input.required = show;
      if (!show) input.value = '';
    }

    select.onchange = syncOtherJobTitleInput;
    syncOtherJobTitleInput();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOtherJobTitleFields);
} else {
  initOtherJobTitleFields();
}

document.addEventListener('turbolinks:load', initOtherJobTitleFields);
window.addEventListener('pageshow', initOtherJobTitleFields);
